module.exports = __webpack_public_path__ + "static/platform-bg-bf247d7e25df9163883f5e10d66b5d43.png";